export default "__VITE_ASSET__DMC1qlCs__"